import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import type { PartialId } from '@attain-apps/string-builder'
import { StringCase, transformCase } from '@attain-apps/string-utils'
import * as rxjs from 'rxjs'

import * as me from '../../../me'
import type { Group } from '../group'

import { Api } from './api'
import * as plugins from './plugins'
import type { TypeParams } from './types'

/**
 * Collection of agent chat messages
 *
 * @see {@link ec.Collection}
 */
export class Collection extends ec.Collection<TypeParams> {
  constructor(assistantGroup: Group) {
    const api = new Api()
    const meFeature = ngCore.inject(me.Feature)

    super({
      api,
      context$: rxjs
        .combineLatest({
          conversation:
            assistantGroup.conversation.plugins.currentEntityPlugin.feature.selectors.getEntity()
              .asObservable,
          zoneContext: meFeature.contexts.selectors.zoneContext.asObservable,
        })
        .pipe(
          rxjs.map(({ zoneContext, conversation }) => {
            if (!zoneContext) {
              return undefined
            }
            return {
              ...zoneContext,
              conversationId: conversation?.id,
            }
          }),
        ),
      identify: message => message.id,
      name: ec.Name.Dynamic.from(
        `${transformCase(assistantGroup.id, StringCase.Title)}Message`,
      ),
      plugins: {
        additionalFactories: [
          new plugins.sender.Factory({ api, assistantGroup }),
        ],
      },
    })
  }
}
